import React, { useMemo } from 'react';
import { NameWithIconWrapper } from '../DataModelerCommonUI';
import DerivedDefinitionIcon from '../../../../components/DerivedDefinitionIcon';
import { TextButton } from '../../../../components/Button';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  columnName: string;
  isDerived: boolean;
  canEditDefinition: boolean;
  onEditDefinitionClick: () => void;
}

const TableColumnName = ({
  columnName,
  isDerived,
  canEditDefinition,
  onEditDefinitionClick,
}: IProps) => {
  return useMemo(() => {
    if (!isDerived) {
      return (
        <KubitTooltip content={columnName}>
          <div>{columnName}</div>
        </KubitTooltip>
      );
    }
    if (!canEditDefinition) {
      return (
        <NameWithIconWrapper>
          <KubitTooltip content={columnName}>
            <div>{columnName}</div>
          </KubitTooltip>
          <DerivedDefinitionIcon tooltipText={'Derived Column'} />
        </NameWithIconWrapper>
      );
    }
    return (
      <NameWithIconWrapper>
        <KubitTooltip
          content={`[Derived Column] Click to edit ${columnName} definition`}
        >
          <TextButton onClick={onEditDefinitionClick}>
            {columnName}
            <DerivedDefinitionIcon />
          </TextButton>
        </KubitTooltip>
      </NameWithIconWrapper>
    );
  }, [isDerived, canEditDefinition, onEditDefinitionClick, columnName]);
};

export default TableColumnName;
